import React from 'react'

export const getOrderDetail = (orderDetail) => {
  switch (orderDetail) {
    case 'O':
      return '즉시주문'
    case 'G':
      return '예약주문'
    case 'C':
      return '드라이브픽업'
    case 'R':
      return '사전예약'
    default:
      return ''
  }
}
